import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { GET_COMPANY_QUERY } from '../../_shared-general/graphql/company.graph';

const useCompanyFull = graphID => {
    const { data, ...rest } = useQuery(GET_COMPANY_QUERY, { variables: { id: graphID } });
    const [company, setCompany] = useState();

    useEffect(() => {
        if (!data) return;

        setCompany(data.node);

        return () => {
            setCompany();
        };
    }, [data]);

    return { data: company, ...rest };
};
export default useCompanyFull;
